import { Button, Text, Grid } from '@simplywallst/ui-core';
import { EditSolid } from '@simplywallst/ui-core/icons';
import { NotePad } from '@/components/Note/components/EmptyState';

interface Props {
  handleAddNote?: () => void;
  canCreateNote?: boolean;
}
export const EmptyState = ({ handleAddNote, canCreateNote }: Props) => (
  <Grid
    templateRows="auto auto auto"
    gap="16px"
    justifyItems="center"
    alignContent="center"
    data-cy-id="empty-note"
  >
    <NotePad />
    <Text textAlign="center" typography="xSmall" color="whiteRGB">
      Capture your thoughts, links and
      <br />
      company narrative
    </Text>
    <Button
      display="block"
      styleType="loud"
      onClick={handleAddNote}
      disabled={!canCreateNote}
    >
      <EditSolid /> Add note
    </Button>
  </Grid>
);
